import React from 'react';


export default class Doctor extends React.Component {
    render() {
        return (
            <div>这是404</div>
        )
    }
}